import { useState } from "react";
import type { Video } from "@/mocks/videos";
import VideoCard from "@/components/base/VideoCard";
import SectionHeading from "./SectionHeading";

interface LatestGridProps {
  videos: Video[];
}

const PAGE_SIZE = 5;

export default function LatestGrid({ videos }: LatestGridProps) {
  const [visible, setVisible] = useState(PAGE_SIZE);
  const shown = videos.slice(0, visible);
  const hasMore = visible < videos.length;

  return (
    <section className="w-full px-4 md:px-8">
      <div className="max-w-[1200px] mx-auto">
        <SectionHeading
          title="最新视频"
          desc="刚刚上线的新鲜内容，第一时间追起来"
          moreTo="/search"
          moreLabel="搜索全部"
        />
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {shown.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
        {hasMore && (
          <div className="mt-6 text-center">
            <button
              type="button"
              onClick={() => setVisible((v) => v + PAGE_SIZE)}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-refresh-line text-lg"></i>
              加载更多
            </button>
          </div>
        )}
      </div>
    </section>
  );
}